module.exports = __webpack_public_path__ + "img/keytana_yes.e45d278f.png";